import React from 'react'
import { PageHeader } from '../Common'
import PracticeSelectView from '../Practices/PracticeSelectView'
import { toPath } from '../../routes'

export default function MissedTransmissions() {
  return (
    <div>
      <PageHeader title="Missed Transmissions" />
      <PracticeSelectView routeMethod={toPath.practices.missedTransmissions} />
    </div>
  )
}
